<script setup>
const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  isActive: {
    type: Boolean,
    default: false,
  },
  isFirst: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
    <section
        class="ConfiguratorGroup lg:tw-pb-3"
        v-if="props.isActive"
        :class="props.isActive ? 'is-active' : ''"
    >
        <h2
            class="ConfiguratorGroupTitle tw-text-gray-700 tw-text-2xl tw-font-medium lg:tw-text-32" 
            :class="props.isActive ? 'tw-mb-6 md:tw-mb-8 lg:tw-mt-8 lg:tw-mb-12' : 'tw-mb-6'"
            v-text="props.title"
        >
        </h2>

        <slot></slot>
    </section>
</template>